"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEdition = exports.getMetadata = exports.mintTokens = exports.mintNFT = exports.createMintTokensInstructions = exports.createMintNFTInstructions = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const spl_token_1 = require("@solana/spl-token");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const transaction_1 = require("../transaction");
const createMintNFTInstructions = async (provider, mintKeypair) => {
    const balanceNeeded = await provider.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
    const createAccountIx = anchor.web3.SystemProgram.createAccount({
        fromPubkey: provider.wallet.publicKey,
        newAccountPubkey: mintKeypair.publicKey,
        lamports: balanceNeeded,
        space: spl_token_1.MINT_SIZE,
        programId: spl_token_1.TOKEN_PROGRAM_ID,
    });
    const createInitMintIx = (0, spl_token_1.createInitializeMintInstruction)(mintKeypair.publicKey, 0, provider.wallet.publicKey, provider.wallet.publicKey);
    const ata = await anchor.utils.token.associatedAddress({
        mint: mintKeypair.publicKey,
        owner: provider.wallet.publicKey,
    });
    const createAtaIx = (0, spl_token_1.createAssociatedTokenAccountInstruction)(provider.wallet.publicKey, ata, provider.wallet.publicKey, mintKeypair.publicKey);
    const createMintToIx = (0, spl_token_1.createMintToInstruction)(mintKeypair.publicKey, ata, provider.wallet.publicKey, 1);
    const [metadataPDA] = await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        mpl_token_metadata_1.PROGRAM_ID.toBuffer(),
        mintKeypair.publicKey.toBuffer(),
    ], mpl_token_metadata_1.PROGRAM_ID);
    const createMetadataAccountV2Ix = (0, mpl_token_metadata_1.createCreateMetadataAccountV2Instruction)({
        metadata: metadataPDA,
        mint: mintKeypair.publicKey,
        mintAuthority: provider.wallet.publicKey,
        payer: provider.wallet.publicKey,
        updateAuthority: provider.wallet.publicKey,
    }, {
        createMetadataAccountArgsV2: {
            data: {
                name: '',
                symbol: '',
                uri: '',
                sellerFeeBasisPoints: 500,
                creators: null,
                collection: null,
                uses: null,
            },
            isMutable: true,
        },
    });
    const [masterEditionPDA] = await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        mpl_token_metadata_1.PROGRAM_ID.toBuffer(),
        mintKeypair.publicKey.toBuffer(),
        Buffer.from('edition'),
    ], mpl_token_metadata_1.PROGRAM_ID);
    const createMasterEditionV3Ix = (0, mpl_token_metadata_1.createCreateMasterEditionV3Instruction)({
        metadata: metadataPDA,
        edition: masterEditionPDA,
        mint: mintKeypair.publicKey,
        updateAuthority: provider.wallet.publicKey,
        mintAuthority: provider.wallet.publicKey,
        payer: provider.wallet.publicKey,
    }, {
        createMasterEditionArgs: {
            maxSupply: new anchor.BN(1),
        },
    });
    return [
        createAccountIx,
        createInitMintIx,
        createAtaIx,
        createMintToIx,
        createMetadataAccountV2Ix,
        createMasterEditionV3Ix,
    ];
};
exports.createMintNFTInstructions = createMintNFTInstructions;
const createMintTokensInstructions = async (provider, mintKeypair, amount, decimals) => {
    const balanceNeeded = await provider.connection.getMinimumBalanceForRentExemption(spl_token_1.MINT_SIZE);
    const createAccountIx = anchor.web3.SystemProgram.createAccount({
        fromPubkey: provider.wallet.publicKey,
        newAccountPubkey: mintKeypair.publicKey,
        lamports: balanceNeeded,
        space: spl_token_1.MINT_SIZE,
        programId: spl_token_1.TOKEN_PROGRAM_ID,
    });
    const createInitMintIx = (0, spl_token_1.createInitializeMintInstruction)(mintKeypair.publicKey, decimals, provider.wallet.publicKey, provider.wallet.publicKey);
    const ata = await anchor.utils.token.associatedAddress({
        mint: mintKeypair.publicKey,
        owner: provider.wallet.publicKey,
    });
    const createAtaIx = (0, spl_token_1.createAssociatedTokenAccountInstruction)(provider.wallet.publicKey, ata, provider.wallet.publicKey, mintKeypair.publicKey);
    const createMintToIx = (0, spl_token_1.createMintToInstruction)(mintKeypair.publicKey, ata, provider.wallet.publicKey, amount);
    return [createAccountIx, createInitMintIx, createAtaIx, createMintToIx];
};
exports.createMintTokensInstructions = createMintTokensInstructions;
const mintNFT = async (provider, mintKeypair) => {
    const ixs = await (0, exports.createMintNFTInstructions)(provider, mintKeypair);
    return await (0, transaction_1.sendTransactionWithRetry)(provider.connection, provider.wallet, ixs, [mintKeypair], 'confirmed');
};
exports.mintNFT = mintNFT;
const mintTokens = async (provider, mintKeypair, amount, decimals) => {
    const ixs = await (0, exports.createMintTokensInstructions)(provider, mintKeypair, amount, decimals);
    return await (0, transaction_1.sendTransactionWithRetry)(provider.connection, provider.wallet, ixs, [mintKeypair], 'confirmed');
};
exports.mintTokens = mintTokens;
const getMetadata = async (mint) => {
    return (await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        mpl_token_metadata_1.PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
    ], mpl_token_metadata_1.PROGRAM_ID))[0];
};
exports.getMetadata = getMetadata;
const getEdition = async (mint) => {
    return (await anchor.web3.PublicKey.findProgramAddress([
        Buffer.from('metadata'),
        mpl_token_metadata_1.PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
        Buffer.from('edition'),
    ], mpl_token_metadata_1.PROGRAM_ID))[0];
};
exports.getEdition = getEdition;
//# sourceMappingURL=index.js.map